import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { ActionLauncher } from "../components/ActionLauncher";
import { CommandPalette } from "../components/CommandPalette";
import { useRealtime } from "../lib/realtime";
import { useGlobalShortcuts } from "../lib/shortcuts";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

/** The shell shared by all eight locked screens: sidebar, top bar, content (ADR 0016 6–10). */
export function AppShell() {
  const { t } = useTranslation();
  const [palette, setPalette] = useState(false);
  const [launcher, setLauncher] = useState(false);
  const live = useRealtime(true);
  const openLauncher = useCallback(() => {
    setPalette(false);
    setLauncher(true);
  }, []);
  const handlers = useMemo(() => ({ palette: () => setPalette(true), newCreative: openLauncher }), [openLauncher]);
  useGlobalShortcuts(handlers);
  return (
    <div className="flex h-full bg-app">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50">
        {t("common.skip_to_content")}
      </a>
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar onSearch={() => setPalette(true)} onNewCreative={openLauncher} />
        {!live && (
          <div role="status" className="sr-only">
            {t("shell.realtime_offline")}
          </div>
        )}
        <main id="main" className="flex-1 overflow-y-auto px-10 py-8">
          <div className="mx-auto max-w-[1400px]">
            <Outlet context={{ live }} />
          </div>
        </main>
      </div>
      <CommandPalette open={palette} onOpenChange={setPalette} onNewCreative={openLauncher} />
      <ActionLauncher open={launcher} onOpenChange={setLauncher} />
    </div>
  );
}
